import React, { useEffect, useState } from 'react';
import { StyleSheet, Text, View, Button, Image, TouchableOpacity } from 'react-native';
import { useRoute } from '@react-navigation/native'; // Import useRoute from @react-navigation/native
import { useSelector } from 'react-redux'; // Import useSelector from react-redux
import { useDispatch } from 'react-redux'; // Import useDispatch from react-redux
import { clearAuthenticated, clearUser } from '../redux/userSlice';

import { FontAwesome } from '@expo/vector-icons';
import { ScrollView } from 'react-native-gesture-handler';



export default function Profile({ navigation }) {
  const dispatch = useDispatch();
    const user = useSelector((state) => state.user);

      // Set options with navigation.setOptions
      useEffect(() => {
        navigation.setOptions({
          // Set your options here
        });
      }, [navigation]);

    const handleLogout = () => {
      dispatch(clearUser());
      dispatch(clearAuthenticated());
      navigation.navigate('Home');
    };

  return (
    <ScrollView style={{backgroundColor: '#fffaeb'}}>
      <View style={styles.container}>
          <Text style={styles.title}>Profile Page</Text>

          {/* Profile Picture */}
          <View style={styles.FontAwesomeIcon}>
            {/* <Image source={ipfLogo} style={styles.ipfLogo} />  */}
            <FontAwesome name="user-circle-o" size={120} color="#6a3669" />
              {/* <Image source={profileData && profileData.photoURL ? { uri: profileData.photoURL } : require('../assets/images/votre-logo-ici.png')} style={styles.profilePicture} /> */}
          </View>

          {/* Profile Info */}
          <Text style={styles.label}>First name:</Text>
          <Text style={styles.info}> {user && user?.user?.firstName || 'N/A' }</Text>
          <Text style={styles.label}>Last name:</Text>
          <Text style={styles.info}>{user && user?.user?.lastName || 'N/A'}</Text>
          <Text style={styles.label}>Email:</Text>
          <Text style={styles.info}>{user && user?.user?.email ? user?.user?.email || 'N/A' : 'N/A'}</Text>
          
          {/* Logout Button */}
          <View style={styles.buttonContainer}>
            <TouchableOpacity
                style={styles.logoutButton}
                onPress={handleLogout}
            >
                <Text style={{color: 'white', fontWeight: 'bold'}}>Logout</Text>
            </TouchableOpacity>
          </View>
          <View style={{ borderBottomColor: '#7E7E7E', borderBottomWidth: 1.5, padding: 5, alignSelf: 'center', width: '8%', maxWidth: 30 }} />
          {/* Home Button */}
          <View style={styles.buttonContainer}>
            <TouchableOpacity
                onPress={() => navigation.navigate('Home')}
                style={styles.goBackButton}
            >
                <Text style={{color: 'white', fontWeight: 'bold'}}>Home</Text>
            </TouchableOpacity>
          </View>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    height: '100%',
    backgroundColor: '#fffaeb',
    alignItems: 'center',
    // justifyContent: 'center',
    marginBottom: 20,
  },
  title: {
    fontSize: 28,
    fontWeight: 'bold',
    marginBottom: 30,
    marginTop: 40,
    color: '#6a3669',
    alignSelf: 'center',
    justifyContent: 'space-around',
    alignContent: 'center',
  },
  FontAwesomeIcon: {
    marginBottom: 20,
  },
  profileInfo: {
    backgroundColor: '#ffffff',
    padding: 20,
    borderRadius: 5,
    borderWidth: 1,
    borderColor: '#ccc',
  },
  label: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 5,
    marginTop: 10,
  },
  info: {
    fontSize: 18,
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
  },
  logoutButton: {
    marginTop: 30,
    paddingHorizontal: 20,
    backgroundColor: '#6a3669',
    paddingVertical: 10,
    borderRadius: 5,
    fontSize: 18,
  },
  goBackButton: {
    paddingHorizontal: 20,
    backgroundColor: '#6a3669',
    paddingVertical: 10,
    borderRadius: 5,
    fontSize: 18,
  },
});
